import axios from "axios";
import store from "@/store";
import Vue from "vue";

/**
 * AxiosInstance contém loading no painel
 */
export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
});

axiosInstance.interceptors.request.use(function (config) {
  store.dispatch("setIsLoading", true, {
    root: true,
  });

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch("setIsLoading", false, {
      root: true,
    });

    return response;
  },
  (error) => {
    store.dispatch("setIsLoading", false, {
      root: true,
    });

    swalError(error);

    throw error;
  }
);

/**
 *
 */
export const axiosWithoutLoading = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
});

axiosWithoutLoading.interceptors.request.use(function (config) {
  return config;
});

axiosWithoutLoading.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    swalError(error);

    throw error;
  }
);

/**
 * added no vue os axios
 */
Vue.prototype.$axiosInstance = axiosInstance;
Vue.prototype.$axiosWithoutLoading = axiosWithoutLoading;

/**
 * method error
 * @param {*} error
 */
function swalError(error) {
  let dataError = {
    message:
      "message" in error.response.data
        ? error.response.data.error
        : error.response.data.statusText,
  };

  if ("data" in error.response && error.response.data) {
    dataError =
      "data" in error.response.data
        ? error.response.data.data
        : error.response.data;
  }

  Vue.swal.fire({
    html: dataError.error ?? dataError.message,
  });
}
